import * as React from 'react'

function SvgCateVariety(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M20.866 9.525l-5.318 3.959 2.113 6.326a.178.178 0 01-.058.196.175.175 0 01-.21.004l-5.444-3.857-5.362 3.964a.187.187 0 01-.11.041.152.152 0 01-.094-.035.179.179 0 01-.073-.2l1.99-6.368-5.43-3.877a.174.174 0 01-.065-.197.173.173 0 01.16-.123h6.678l2.006-6.435a.178.178 0 01.172-.12c.077 0 .141.044.164.111l2.133 6.444h6.954l-.207.167zm.901-.166c0-.24-.095-.796-.978-.797h-6.094l-.021-.063-1.933-5.836A.978.978 0 0011.808 2a.976.976 0 00-.918.683l-1.832 5.88H2.96a.965.965 0 00-.914.677c-.13.403.015.84.36 1.087l4.96 3.541-.02.064-1.796 5.753a.968.968 0 00.363 1.081.994.994 0 001.145-.009l4.9-3.622 4.968 3.522c.323.234.823.23 1.148-.01a.972.972 0 00.34-1.089l-1.93-5.78 4.874-3.627a.977.977 0 00.408-.792z" />
    </svg>
  )
}

export default SvgCateVariety
